'use client';

import Style from './skeleton-loader.module.scss';

const SkeletonLoader = ({ className, isShow, ...props }) => {
  if(!isShow) return null;
  return <div className={`${Style["skeleton-loader"]} ${className}`} {...props}></div>;
};

export default SkeletonLoader;

